import {Skeleton} from "antd";

type LabeledInputProps = {
  label: React.ReactNode;
  children: React.ReactNode;
  isLoading: boolean
};

export const LabeledInput = ({label, children, isLoading}: LabeledInputProps) => (
    <div className="flex flex-col md:flex-row md:items-center md:gap-3">
      <div>
        <label className="md:w-32 font-medium">
          {isLoading && <Skeleton.Input active/>}
          {!isLoading && label}
        </label>
      </div>
      <div className="flex-1">
        {isLoading && <Skeleton.Input className={"w-full!"} active />}
        {!isLoading && children}</div>
    </div>
);